import { useContext } from 'react';
import UserContext from 'modules/common/context/UserContext';
import { EDITOR_USER_GROUP } from 'modules/common/constants';

export function useIsEditorRole() {
  const { userGroups } = useContext(UserContext);

  return userGroups?.includes(EDITOR_USER_GROUP);
}
